/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ solution: NonNullable<unknown> }} Task_Solution_LegacyInputs */

const en_task_solution_legacy = /** @type {(inputs: Task_Solution_LegacyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The recorded solution "${i?.solution}" is no longer configured for this task type.`)
};

const pt_br2_task_solution_legacy = /** @type {(inputs: Task_Solution_LegacyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A solução registrada "${i?.solution}" não está mais configurada para este tipo de atividade.`)
};

/**
* | output |
* | --- |
* | "The recorded solution \"{solution}\" is no longer configured for this task type." |
*
* @param {Task_Solution_LegacyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_solution_legacy = /** @type {((inputs: Task_Solution_LegacyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Solution_LegacyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_solution_legacy(inputs)
	return pt_br2_task_solution_legacy(inputs)
});